import { endPointSubscriptionPreview } from "modules/main/services/endpoints";
import { apiRequest } from "modules/main/services/apiRequest";

export type SubscriptionOfferType = "regular" | "corporate_discounted";

export interface SubscriptionPreview {
    eligible: boolean;
    offer_type: SubscriptionOfferType;
    badge_label: string | null;
    headline: string;
    display_price: string;
    roi_hook: string;
    partner_name: string | null;
    partner_logo_url: string | null;
    trial_days?: number | null;
}

export const REGULAR_SUBSCRIPTION_PREVIEW: SubscriptionPreview = {
    eligible: false,
    offer_type: "regular",
    badge_label: "Carriapp Plus",
    headline: "Carriapp, sigue ahorrando todo el mes",
    display_price: "$3.990 / mes",
    roi_hook: "Una sola optimización ya te paga la suscripción",
    partner_name: null,
    partner_logo_url: null,
    trial_days: null,
};

/**
 * Fetches the backend-owned Plus checkout preview for the current session.
 * @returns Subscription preview metadata controlled by the backend.
 */
export const fetchSubscriptionPreview = async (): Promise<SubscriptionPreview> => {
    return apiRequest<SubscriptionPreview>(endPointSubscriptionPreview);
};
